import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import { transformResultsFromObjectSplitByVendor } from 'util/data';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    name = 'awsProducts',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.awsProducts.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        instanceEndpoint:   endpoints.awsProducts.instanceEndpoint,
        transformResultsFn: json => transformResultsFromObjectSplitByVendor(json.results, 'AWS')
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/awsProducts.js